import { StyledButtonBase } from './styles';

import { withLayoutProps } from '../../utils/withLayoutProps';

import type { ButtonSize, ButtonVariant } from './styles';
import type { ReactNode } from 'react';

interface ButtonProps {
  onClick?: () => void;
  children: ReactNode;
  variant?: ButtonVariant;
  round?: boolean;
  disabled?: boolean;
  size?: ButtonSize;
  type?: HTMLButtonElement['type'];
  fullWidth?: boolean;
  disableCapslock?: boolean;
  chevron?: boolean;
}

export const Button = withLayoutProps(
  ({
    onClick,
    type,
    children,
    variant = 'primary',
    round = false,
    disabled,
    size = 'default',
    fullWidth = false,
    disableCapslock = false,
    chevron = false,
    ...props
  }: ButtonProps) => (
    <StyledButtonBase
      onClick={onClick}
      type={type}
      $round={round}
      $variant={variant}
      disabled={disabled}
      $size={size}
      $fullWidth={fullWidth}
      $disableCapslock={disableCapslock}
      $chevron={chevron}
      {...props}
    >
      {children}
    </StyledButtonBase>
  ),
);
